import api from "@/services/api";
import type {
	InsightHelpfulPayload,
	InsightHelpfulResponse,
	InsightQueryParams,
	InsightResolvePayload,
	InsightResolveResponse,
	InsightResponse,
} from "../types";

export { getInsightsSummary } from "@services";

const RESOLVE_INSIGHT_PAYLOAD: InsightResolvePayload = {
	isResolved: true,
};

export async function getInsights(
	params: InsightQueryParams
): Promise<InsightResponse> {
	const { data } = await api.get<InsightResponse>("/api/insight", {
		params,
	});
	return data;
}

export async function resolveInsight(
	insightId: number
): Promise<InsightResolveResponse> {
	const { data } = await api.put<InsightResolveResponse>(
		`/api/insight/${insightId}/resolution`,
		RESOLVE_INSIGHT_PAYLOAD
	);
	return data;
}

export async function submitInsightHelpful(
	insightId: number,
	wasHelpful: boolean
): Promise<InsightHelpfulResponse> {
	const payload: InsightHelpfulPayload = { wasHelpful };
	const { data } = await api.put<InsightHelpfulResponse>(
		`/api/insight/${insightId}/helpful`,
		payload
	);
	return data;
}
